'use strict';

module.exports = /*@ngInject*/ ["$rootScope", "$q", function ($rootScope, $q) {

    function success(response) {
        return response;
    }

    function error(response) {
        var status = String(response.status);
        var $state = $rootScope.getState();
        var allow = ["500", "0"];
        if ($rootScope.isLoggedIn()) {
            if (status !== "0" && status !== "404") {
                $rootScope.logError(response, $rootScope.user.id);
            }
            if (allow.indexOf(status) === -1 && response.config.url !== "noc/base/error.html") {
                $state.go('error', {error: status}, {location: "replace"});
            }

        } else{
            $state.go('login');
        }

        return $q.reject(response);
    }

    return function (promise) {
        return promise.then(success, error);
    };
}];